<template>
    <v-card>
        <form @submit.prevent="$emit('submit', data)" ref="form">
            <v-card-text class="text--primary">
                <v-text-field
                    v-model="data.name"
                    :label="$t('label.title')"
                    required
                    filled
                    type="text"
                ></v-text-field>
                <v-textarea
                    filled
                    v-model="data.description"
                    :label="$t('label.description')"
                ></v-textarea>
                <h3 class="title" v-t="'title.plan_image'"></h3>
                <br />
                <label
                    v-show="!data.file"
                    :for="'fileUpload'"
                    class="add-file v-btn v-btn--text v-btn--round theme--dark green--text"
                >
                    <template v-if="data.image">{{ $t("button.upload_new_plan_image") }}</template>
                    <template v-else>{{ $t("button.upload_plan_image") }}</template>
                    <i
                        data-v-19882d02
                        aria-hidden="true"
                        class="v-icon v-icon--right material-icons"
                        >add_circle</i
                    >
                    <input
                        ref="fileUpload"
                        class="custom-file-input"
                        type="file"
                        :required="!data.image"
                        name="fileUpload"
                        accept="image/png, image/jpeg, image/tiff"
                        @change="chooseFile"
                        :multiple="false"
                        :id="'fileUpload'"
                    />
                </label>
                {{ $t("hint.upload_image") }}
                <br />
                <v-layout>
                    <v-flex v-if="objectURL" xs12>
                        <div class="image-preview" style="max-width:700px">
                            <img :src="objectURL" />
                            <v-btn @click="removeFile" type="button" color="error" icon large text>
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex v-else-if="data.image" xs12>
                        <div class="image-preview" style="max-width:700px">
                            <img :src="data.image.thumb.url" />
                            <v-btn
                                @click="data.image = null"
                                type="button"
                                color="error"
                                icon
                                large
                                text
                            >
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <BaseDelete @click="$emit('remove')" :loading="loading" v-if="!adding" />
                <v-spacer></v-spacer>
                <v-btn type="button" @click="$emit('cancel')" color>{{
                    $t("button.cancel")
                }}</v-btn>
                <v-btn type="submit" color="primary" :disabled="loading" :loading="loading">{{
                    $t("button.save")
                }}</v-btn>
            </v-card-actions>
        </form>
    </v-card>
</template>

<script>
import Vue from "vue"
export default {
    props: {
        loading: { type: Boolean, default: false },
        adding: { type: Boolean, default: false },
        value: { type: Object, required: false, default: null },
    },
    data() {
        return {
            data: { name: "", description: "", image: null, file: null },
            objectURL: null,
        }
    },
    mounted() {
        this.data = Object.assign({}, this.value)
    },
    methods: {
        async chooseFile(event) {
            if (event.target.files.length > 0) {
                const file = event.target.files[0]
                if (file.size / 1000000 >= 30) {
                    this.$notify({ type: "error", title: this.$i18n.t("notify.maximum_30mb") })
                    return
                }
                this.data.image = null
                this.data.file = null
                this.objectURL = null
                this.data.file = event.target.files[0]
                this.objectURL = URL.createObjectURL(this.data.file)
            }
        },

        removeFile() {
            this.$refs.fileUpload.value = ""

            if (!/safari/i.test(navigator.userAgent)) {
                this.$refs.fileUpload.type = ""
                this.$refs.fileUpload.type = "file"
            }
            this.data.file = null
            this.objectURL = null
            this.data.image = null
        },
    },
}
</script>

<style scoped lang="scss">
.add-file {
    cursor: pointer;
}
.custom-file-input {
    height: 1px;
    width: 1px;
    filter: opacity(0);
}
.image-preview {
    position: relative;
    img {
        width: 100%;
    }
    button {
        position: absolute;
        top: 6px;
        right: -1px;
    }
}
</style>
